import React, {memo} from 'react';
import {Link} from "react-scroll";
import PropTypes from 'prop-types';
import './scrollToButton.scss';

const ScrollToButton = ({duration, elementId, offset = 0}) => (
    <Link spy smooth='easeOutCirc' duration={duration ? duration : 1500} to={elementId} offset={offset} className='bottomScrollIcon'>
        <svg className='arrows'>
            <path className='a1' d='M0 0 L15 16 L30 0'/>
            <path className='a2' d='M0 10 L15 26 L30 10'/>
        </svg>
    </Link>
)

ScrollToButton.propTypes = {
    duration: PropTypes.number.isRequired,
    elementId: PropTypes.string.isRequired,
}

export default memo(ScrollToButton);